<template>
  <div class="main">
    <div class="banner">
      <swiper ref="mySwiper" :options="swiperOptions1">
        <swiper-slide>
          <img src="~@/assets/imgs/m_banner1.png" alt />
        </swiper-slide>
        <swiper-slide>
          <img src="~@/assets/imgs/m_banner2.png" alt />
        </swiper-slide>
        <swiper-slide>
          <img src="~@/assets/imgs/m_banner3.png" alt />
        </swiper-slide>
        <swiper-slide>
          <img src="~@/assets/imgs/m_banner4.png" alt />
        </swiper-slide>
      </swiper>

      <div class="swiper-pagination swiper-pagination1" slot="pagination"></div>
    </div>
    <div class="solve">
      <div class="solve-container w">
        <div class="m-title">
          <h2>医药零售管理系统一体化解决方案</h2>
          <p>深耕细分行业，提供更加垂直的行业解决方案</p>
        </div>
        <ul class="solve-list">
          <li class="solve-item" v-for="(item,index) in solveList" :key="index">
            <div class="solve-item-left">
              <svg-icon :icon-class="item.svg" class-name="solve-svg"></svg-icon>
            </div>
            <div class="solve-item-right">
              <h3>{{item.name}}</h3>
              <p>{{item.content}}</p>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div class="system">
      <div class="system-container w">
        <div class="m-title m-gray">
          <h2>
            安全稳定完善的管理系统
            <br />助力企业突破经营瓶颈
          </h2>
          <p>深耕细分行业，提供更加垂直的行业解决方案</p>
        </div>

        <div class="ststem-wrapper" v-for="items in (systemList.length/3)" :key="items">
          <ul class="system-nav">
            <li
              v-for="(item,index) in systemListFn(3*items)"
              :key="item.id"
              :class="{active:systemNumFn(items)==index}"
              @mouseover="systemOver(index,items)"
            >{{item.nav}}</li>
          </ul>
          <div
            class="system-content"
            v-for="(item,index) in systemListFn(3*items)"
            :key="item.id"
            v-show="index == systemNumFn(items)"
          >
            <div class="sytem-inner">
              <p>{{item.content}}</p>
              <router-link class="try-btn" to="/try">
                申请使用
                <svg-icon icon-class="icon_arrow_right" class-name="icon_arrow_right"></svg-icon>
              </router-link>
            </div>
            <div class="system-tag" :class="{tag272:item.tag.length<=4}">
              <div class="system-tag-item" v-for="tagItem in item.tag" :key="tagItem.id">
                <div class="system-icon">
                  <svg-icon :icon-class="tagItem.svg" class-name></svg-icon>
                </div>
                <p>{{tagItem.text}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="repute">
      <div class="repute-container w">
        <div class="m-title">
          <h2>19年技术积累成就行业口碑</h2>
          <p>全面提高用户的满意度，不断超越用户期望</p>
        </div>
        <ul class="repute-list">
          <li v-for="(item,index) in reputeList" :key="index">
            <h3>{{item.name}}</h3>
            <p>{{item.content}}</p>
          </li>
        </ul>
      </div>
    </div>

    <div class="milepost">
      <div class="milepost-container w">
        <div class="m-title m-white">
          <h2>懂你所需，引领先机</h2>
          <p>走在更“先”之路，从容智破万变</p>
        </div>
        <div class="milepost-wrapper">
          <swiper ref="mySwiper" :options="swiperOptions2">
            <swiper-slide v-for="item in milepostList" :key="item.id">
              <div class="slide-wrapper">
                <div class="milepost-time">{{item.time}}</div>
                <div class="milepost-name">{{item.name}}</div>
                <div class="milepost-content">
                  <p>政策：{{item.policy}}</p>
                  <p>内容：{{item.content}}</p>
                </div>
              </div>
            </swiper-slide>
          </swiper>

          <div class="swiper-pagination swiper-pagination2" slot="pagination"></div>
        </div>
      </div>
    </div>

    <!-- <div class="cooperate">
      <div class="cooperate-container w">
        <div class="m-title">
          <h2>合作客户</h2>
        </div>
        <ul class="cooperate-list">
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
        </ul>
      </div>
    </div>-->

    <div class="apply">
      <h3>现在申请使用 立享优惠！</h3>
      <router-link to="/try">申请使用</router-link>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      swiperOptions1: {
        pagination: {
          el: ".swiper-pagination1",
          clickable: true
        },
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: true
        },
        loop: true
      },
      swiperOptions2: {
        pagination: {
          el: ".swiper-pagination2",
          clickable: true
        },
        speed: 500,
        slidesPerView: "auto",
        centeredSlides: true,
        spaceBetween: 16,
        loop: true,
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: true
        }
      },
      solveList: [
        {
          svg: "index_system1",
          name: "紧随政策导向，准抓市场趋势",
          content:
            "强大的资深行业团队，时刻快速迭代系统升级，造就永不过时的管理系统。"
        },
        {
          svg: "index_system2",
          name: "强大的兼容功能",
          content:
            "跨地域兼容，对接不同省市药监局、医保接口，多样式支付，定制开发接口。"
        },
        {
          svg: "index_system3",
          name: "全面信息化管理医药零售企业",
          content:
            "满足药店、中医馆、诊所的信息化管理需求，助力医药零售企业的发展迈上新台阶。"
        },
        {
          svg: "index_system4",
          name: "专业数据诊断及行业咨询服务",
          content:
            "多样化数字报表，智能提供专业管理数据分析，助力诊断运营问题，为药店提供数据分析及经营意见。"
        }
      ],
      reputeList: [
        {
          name: "工作日6*24h",
          content: "提供工作日6天×8小时日常解答与处理客户问题"
        },
        { name: "节假日*8h", content: "法定节假日×8小时解答处理客户问题" },
        {
          name: "20min内必应",
          content: "20分钟内必回应客户问题"
        },
        {
          name: "7*24h",
          content: "提供7*24小时应急服务热线"
        }
      ],
      systemNum1: 0,
      systemNum2: 0,
      systemList: [
        {
          id: 0,
          nav: "ERP系统",
          tag: [
            { svg: "index_system1", text: "自动补货" },
            { svg: "index_system2", text: "会员疗程追踪" },
            { svg: "index_system3", text: "沉睡会员唤醒" },
            { svg: "index_system4", text: "各类数据分析" },
            { svg: "index_system5", text: "会员短信平台" }
          ],
          content:
            "ERP系统是单体药店和连锁药店的管理助手，简易实用功能，符合国家最新GSP需求，高效辅助药店精细化管理药品、会员，助力药店精准营销带动业绩增长。"
        },
        {
          id: 1,
          nav: "云会员营销",
          tag: [
            { svg: "index_system6", text: "会员中心" },
            { svg: "index_system7", text: "健康管理" },
            { svg: "index_system8", text: "健步人生" },
            { svg: "index_system9", text: "微信商城" },
            { svg: "index_system10", text: "公众号代运营" }
          ],
          content:
            "围绕线上会员，提供健康管理工具、营销工具、专业诊疗平台，触达精准目标会员，提高会员忠诚度，构建药店与会员的良性互动关系。"
        },
        {
          id: 2,
          nav: "中医诊疗",
          tag: [
            { svg: "index_system11", text: "充值/储值" },
            { svg: "index_system12", text: "线上预约（挂号）" },
            { svg: "index_system13", text: "微信商城" },
            { svg: "index_system14", text: "健康检测" },
            { svg: "index_system15", text: "诊间互通" }
          ],
          content:
            "厚科中医诊疗系统打造出一个互联网的闭环，通过微信平台完成从预约、付费、轻问诊到医患的持续沟通，形成“互联网＋中医药”模式，在中医养生保健、健康管理、中医特色康复和健康养老等方面发挥重要作用。"
        },
        {
          id: 3,
          nav: "慢病管理",
          tag: [
            { svg: "index_system16", text: "慢病专员作业" },
            { svg: "index_system17", text: "个人慢病管理计划" },
            { svg: "index_system18", text: "慢病追踪" },
            { svg: "index_system19", text: "疗效评估" },
            { svg: "index_system20", text: "满意度调查" }
          ],
          content:
            "三大慢病管理，锁定主要消费群体；七大健康管理，涵盖最有价值的消费群体"
        },
        {
          id: 4,
          nav: "盘点机",
          tag: [
            { svg: "index_system21", text: "实时库存" },
            { svg: "index_system22", text: "动销盘点" },
            { svg: "index_system23", text: "静态盘点" },
            { svg: "index_system24", text: "采购录单" },
            { svg: "index_system25", text: "互调录单" }
          ],
          content:
            "无缝对接 ERP 系统，实时同步单据和保存盘点单 。支持实时动销盘点，告别停业盘点。即可实时查询库存，亦能一键录（购进/退货/互调）单。"
        },
        {
          id: 5,
          nav: "在线教育",
          tag: [
            { svg: "index_system26", text: "PC端与移动端APP" },
            { svg: "index_system27", text: "线上学习与考试" },
            { svg: "index_system28", text: "学习进度环" },
            { svg: "index_system29", text: "学习与考试情况分析" }
          ],
          content:
            "一款为企业专属提供的信息化培训方案，突破了时间和空间的限制，更大程度的节约了药房人员在培训学习中的时间与费用等问题。让学员学习时间更加自由化，满足学员学习时间碎片化的需求，提高学习效率。"
        }
      ],

      milepostNum: 0,
      milepostList: [
        {
          time: "2014",
          name: "新版GSP功能",
          policy:
            "2013年国家食品药品监督管理总局发布关于贯彻实施新修订《药品经营质量管理规范》的通知，并要求在2015年年底前完成新修订药品GSP的实施工作。",
          content:
            "政策出台后，厚科技术第一时间安排技术人员亲临各区域药店过证现场，收集药监局的个性要求，在最短时间内完善新版GSP功能。"
        },
        {
          time: "2015",
          name: "在线教育系统",
          policy:
            "2015年在线教育用户规模已突破1亿，在线教育市场达1482.6亿元。随着信息技术的迅速发展，特别是从互联网到移动互联网，创造了跨时空的生活、工作和学习方式，使知识获取的方式发生了根本性的变化。在移动互联网技术和学习需求的双重加持下，在线教育成为新的发展趋势。",
          content:
            "厚科技术为提高药店学员的学习效率及专业知识储备量，创建出具有丰富的知识库体系的“在线教育系统”，突破了时空的限制，满足了移动互联网时代学员碎片化学习的需求，提升企业的核心竞争力。"
        },
        {
          time: "2015",
          name: "慢病管理系统",
          policy:
            "随着经济、社会的迅速发展，人口老年化速度也在逐步加快，相伴随的是慢性病呈井喷式发展。为了遏制慢性病的增长，完善慢病管理模式，促使慢病管理能够有效的进行。国家发布了2012年《中国慢性病防治工作规划》、2014《中国居民慢性病与营养监测工作方案》、2016年《国务院关于印发促进大数据发展行动纲要的通知》、2017年《中国防治慢性病中长期规划》等相关政策，旨在利用互联网技术推动慢病管理服务的发展。",
          content:
            "厚科技术凭借强大的技术研发能力，借鉴国际药房的成功经验，融合先进的管理理念，研发出在行业内处于领先优势的慢病管理系统。"
        },
        {
          time: "2017",
          name: "聚合支付",
          policy:
            "2013年以来，伴随着支付宝、微信支付等第三方移动支付平台的崛起，中国移动支付蓬勃发展。2017年，中国移动支付规模达202.93万亿，全球排名第一。但由此带来的是支付场景呈现崩裂式的“碎片化”，为此，聚合支付应运而生，为消费者和商户提供灵活、便捷、全场景、全渠道的支付服务。",
          content:
            "厚科技术抓住时代趋势，系统快速更新完成支付宝、微信支付、微信会员卡支付的支付功能，实现聚合支付。"
        },
        {
          time: "2017",
          name: "微信会员营销系统",
          policy:
            "2017年微信活跃用户已近10亿人，其中微信公众号已超过1000万个，月活跃粉丝数为7.97亿，加之新零销的横空出世，使微信会员成为药店另一个更便捷、更精准的会员营销工具。",
          content:
            "2017年，厚科技术实现会员卡无缝对接，开发出扫码开卡、会员卡储值、支付、推送等功能。为药店开辟新的会员营销渠道，精准触达目标顾客。"
        },
        {
          time: "2018",
          name: "中医诊疗系统",
          policy:
            "2016年我国颁布《中国人民共和国中医药法》，紧接着发布2016年《中医药发展“十三五”规划》、2017年《中医诊所备案管理暂行办法》等相关政策，中医药迎来蓬勃发展。",
          content:
            "在政策的扶持下，中医馆诊所迎来发展的黄金时间。厚科技术迅速推出中医诊疗系统，旨在解决中医馆诊所的门店管理及线上预约挂号等问题。"
        },
        {
          time: "2018",
          name: "深圳新医保",
          policy:
            "2018年深圳市人力资源和社会保障局发布关于社保新信息系统上线通知，要求深圳所有药店进行医保测试，并在同年10月4日14时正式切换。",
          content:
            "厚科技术在第一时间开发好新版医保接口，并为500+药店进行测试，在10月4日至5日的黄金周期间，通宵奋战为400多家药店成功切换深圳新版医保系统。"
        }
      ],
      timer: null
    };
  },
  mounted() {
    this.setInterval();
  },
  methods: {
    milepostOver(index) {
      this.milepostNum = index;
      clearInterval(this.timer);
    },
    setInterval() {
      this.timer = setInterval(() => {
        this.milepostNum = this.milepostNum + 1;
        if (this.milepostNum >= this.milepostList.length) {
          this.milepostNum = 0;
        }
        console.log(this.milepostNum);
      }, 10000);
    },
    systemOver(index, num) {
      this["systemNum" + num] = index;
    },
    systemListFn(key) {
      return this.systemList.filter((currentValue, index) => {
        return index >= key - 3 && index < key;
      });
    },
    systemNumFn(key) {
      return this["systemNum" + key];
    }
  }
};
</script>
<style lang='scss' scoped>
.banner {
  width: 750px;
  height: 1040px;
  background: #6404dc;
  position: relative;
  .swiper-container {
    width: 100%;
    height: 1040px;
    position: relative;
    img {
      width: 100%;
    }

    .banner-content {
      width: 100%;
      position: absolute;
      left: 0;
      top: 230px;
      .banner-title {
        font-size: 58px;
        font-weight: 300;
        color: #fff;
        line-height: 80px;
        text-align: center;
      }
      .banner-desc {
        color: #fff;
        margin-top: 32px;
        text-align: center;
        font-size: 34px;
        font-weight: 400;
        line-height: 48px;
      }
    }
  }
  .swiper-pagination1 {
    width: 100%;
    bottom: 160px;
    & /deep/ .swiper-pagination-bullet {
      border-radius: initial;
      margin-right: 16px;
      width: 100px;
      height: 4px;
      background: rgba(255, 255, 255, 1);
      opacity: 0.5;
    }
    & /deep/ .swiper-pagination-bullet-active {
      opacity: 1;
    }
  }
}

.solve {
  padding: 72px 32px;
  .solve-list {
    width: 100%;
    margin: 0 auto;
    .solve-item {
      width: 100%;
      padding: 32px 0;
      display: flex;
      &:not(:last-child) {
        border-bottom: 2px solid #d8d8d8;
      }
      .solve-item-left {
        width: 144px;
        height: 144px;
        background: #213d81;
        border-radius: 50%;
        font-size: 72px;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        flex-shrink: 0;
      }
      .solve-item-right {
        margin-left: 32px;
        h3 {
          margin-bottom: 30px;
          font-weight: 300;
          font-size: 36px;
          color: rgba(0, 0, 0, 0.85);
          line-height: 50px;
        }
        p {
          font-size: 24px;
          font-weight: 300;
          color: rgba(0, 0, 0, 0.45);
          line-height: 42px;
          letter-spacing: 1px;
        }
      }
    }
  }
}

.system {
  padding: 72px 0 0;
  width: 100%;
  height: 2812px;
  background: url("../../assets/imgs/m_system_bg.png") no-repeat top center /
    100% 2812px;
  .system-nav {
    @include clearfix;
    li {
      float: left;
      width: 250px;
      height: 112px;
      text-align: center;
      font-size: 40px;
      font-weight: 300;
      color: rgba(255, 255, 255, 0.65);
      line-height: 112px;
      border-bottom: 2px solid rgba(255, 255, 255, 0.65);
      cursor: pointer;
    }
    .active {
      color: #fff;
      border-bottom: 8px solid #fff;
    }
  }
  .system-content {
    .system-tag {
      width: 100%;
      text-align: center;
      font-size: 0;
      .system-tag-item {
        display: inline-block;
        width: 250px;
        margin-bottom: 16px;
        padding: 32px 0;
        .system-icon {
          width: 144px;
          height: 144px;
          background: rgba(255, 255, 255, 0.15);
          border: 2px solid rgba(255, 255, 255, 1);
          border-radius: 50%;
          font-size: 72px;
          display: inline-flex;
          justify-content: center;
          align-items: center;
        }
        p {
          margin-top: 28px;
          font-size: 24px;
          font-weight: 400;
          color: #fff;
          line-height: 34px;
          text-align: center;
          @include ellipsis(2);
        }
      }
    }
    .tag272 {
      width: 500px;
      margin: 0 auto;
    }
    .sytem-inner {
      padding: 48px;
      p {
        font-size: 32px;
        font-weight: 300;
        color: #fff;
        line-height: 52px;
      }
      .try-btn {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 32px;
        font-weight: 400;
        color: #fff;
        line-height: 68px;
        text-align: center;
        margin-top: 48px;
        width: 270px;
        height: 72px;
        background: rgba(255, 255, 255, 0.15);
        border-radius: 4px;
        border: 2px solid #fff;
        .icon_arrow_right {
          margin-left: 8px;
          font-size: 44px;
          font-weight: bold;
          color: #fff;
          display: inline-block;
        }
      }
    }
  }
}

.repute {
  padding: 110px 0;
  background: #f4f4f4;
  height: 1024px;
  .repute-list {
    width: 650px;
    height: 484px;
    background: url("../../assets/imgs/m_index_repute_bg.svg") no-repeat top
      center / 100%;
    margin: 58px auto;
    position: relative;
    li {
      width: 282px;
      height: 136px;
      position: absolute;
      padding: 10px 18px;
      h3 {
        font-size: 32px;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        line-height: 42px;
      }
      p {
        font-size: 22px;
        font-weight: 300;
        color: rgba(255, 255, 255, 1);
        line-height: 28px;
        margin-top: 2px;
      }
    }
    li:nth-child(1) {
      left: 0;
      top: 0;
    }
    li:nth-child(2) {
      right: 20px;
      top: 0px;
    }
    li:nth-child(3) {
      left: 0;
      bottom: 0;
    }
    li:nth-child(4) {
      right: 0;
      bottom: 0;
    }
  }
}

.milepost {
  padding: 96px 0 0;
  width: 100%;
  height: 1678px;
  background: url("../../assets/imgs/m_milepost_bg.png") no-repeat top center /
    100% 100%;
  .milepost-wrapper {
    margin-top: 100px;
    .milepost-time {
      font-size: 64px;
      font-weight: 300;
      color: #fff;
      line-height: 90px;
      text-align: center;
    }
    .milepost-name {
      font-size: 72px;
      font-weight: 300;
      color: #fff;
      line-height: 100px;
      text-align: center;
    }
    .milepost-content {
      font-size: 34px;
      font-weight: 300;
      color: #fff;
      line-height: 52px;
      margin-top: 48px;
      text-align: justify;
    }
  }
  .swiper-slide {
    width: 654px;
    height: 1150px;
    background: rgba(255, 255, 255, 0.15);
    border-radius: 8px;
    border: 2px solid rgba(255, 255, 255, 1);
    padding: 48px 32px 100px;
  }
  .swiper-pagination2 {
    width: 100%;
    margin-top: 32px;
    & /deep/ .swiper-pagination-bullet {
      width: 8px;
      height: 8px;
      background: rgba(255, 255, 255, 1);
      opacity: 0.39;
      margin-right: 16px;
    }
    & /deep/ .swiper-pagination-bullet-active {
      width: 26px;
      background: rgba(255, 255, 255, 1);
      border-radius: 4px;
      opacity: 1;
    }
  }
}

.cooperate {
  padding: 72px 24px 24px;
  .cooperate-list {
    @include clearfix;
    li {
      float: left;
      width: 320px;
      height: 80px;
      background: #eee;
      margin-bottom: 48px;
      &:nth-child(2n) {
        margin-left: 62px;
      }
    }
  }
}

.apply {
  width: 100%;
  height: 240px;
  background: url("../../assets/imgs/apply_bg.png") no-repeat top center / 100%
    100%;
  padding: 42px 0 24px;
  h3 {
    color: #fff;
    text-align: center;
    font-size: 40px;
    font-weight: 300;
    line-height: 56px;
  }
  a {
    display: block;
    background: #fff;
    color: #213d81;
    line-height: 80px;
    margin: 32px auto 0;
    text-align: center;
    width: 320px;
    height: 80px;
    border-radius: 4px;
    font-size: 28px;
    font-weight: 400;
  }
}
</style>